
const defaults = {
  ZIP_CODE_SERVICE_ENDPOINT: '',
  IDENTIFIER_GET_ZIP_CODE: '',
};

export default class ZipCodeService {
  constructor(options = {}) {
    this.options = { ...defaults, ...options };

    if (this.options.ZIP_CODE_SERVICE_ENDPOINT === '') {
      throw new Error('You must set ZIP_CODE_SERVICE_ENDPOINT option');
    }
    this.fetchZipCode = this.fetchZipCode.bind(this);
  }

  async fetchZipCode(ZipCode) {
    const endpoint = this.options.ZIP_CODE_SERVICE_ENDPOINT.concat(
      '/',
      this.options.IDENTIFIER_GET_ZIP_CODE,
      '&codigo=',
      ZipCode,
    );

    return await fetch(endpoint)
      .then(e => e.json())
      .then(res => res)
      .catch(err => err);
  }
}